import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {connect} from 'react-redux';

const PublicRoute = ({isLoggedIn}) => {
    const isAuthenticated = isLoggedIn || localStorage.getItem('token');
    return isAuthenticated ? <Navigate to="/" replace /> : <Outlet />;
};

const mapStateToProps = (state) => ({
    isLoggedIn: state.auth.isLoggedIn
});

export default connect(mapStateToProps)(PublicRoute);
